<template>
  <a-layout-header class="m-header" v-if="getScreen">
    <div>
      <a-button class="m-drawer-toggle" icon="align-left" @click="showDrawer"></a-button>
      <Mis-Navigation />
    </div>
    <div>
      <a-menu mode="horizontal" class="m-header-right">
        <a-menu-item key="apps">
          <router-link :to="{name: 'app'}">
            <Icon type="icon-pandapakita" />
          </router-link>
        </a-menu-item>
        <a-menu-item key="notif" @click="handleNotification">
          <a-badge
            class="m-badge m-badge-small"
            :count="getNotification.aksi.length + getNotification.informasi.length"
            :numberStyle="{backgroundColor: 'red'}"
            v-if="getNotification.aksi.length > 0 || getNotification.informasi.length > 0"
          >
            <a-icon type="notification" />
          </a-badge>
          <a-icon type="notification" v-else />
        </a-menu-item>
        <a-menu-item key="home">
          <router-link :to="{name: 'beranda'}"></router-link>
          <a-icon type="home" />
          <span>&nbsp;Beranda</span>
        </a-menu-item>
        <a-menu-item key="avatar">
          <a-avatar :src="getAuth.foto" style="border:1px solid whitesmoke" size="small"></a-avatar>
        </a-menu-item>
      </a-menu>
    </div>
  </a-layout-header>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["getDrawer", "getScreen", "getNotification", "getAuth"]),
  },
  props: {
    action: Boolean,
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      member: new FormData(),
      visible: {
        notification: false,
        drawer: false,
      },
    };
  },
  methods: {
    ...mapActions({
      DRAWER_TOGGLE: "DRAWER_TOGGLE",
    }),
    showDrawer() {
      this.visible.drawer = !this.getDrawer;
      this.DRAWER_TOGGLE(this.visible.drawer);
    },
    showModal() {
      this.visible.drawer = true;
    },
    handleCancel() {
      this.visible.drawer = false;
    },
    handleCreate() {
      const form = this.$refs.collectionForm.form;
      form.validateFields((err, values) => {
        if (err) {
          return;
        }

        this.member.append("name", values.name);
        this.member.append("role", values.role);
        this.member.append("photo", values.photo);

        axios({
          method: "post",
          url: this.$serviceUrl + "api/member",
          data: this.member,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        })
          .then(function () {
            Event.$emit("newMember");
          })
          .catch(function (response) {
            console.log("error : " + response);
          });
        this.visible.drawer = false;
      });
    },
    handleNotification() {
      this.$store.dispatch("SET_NOTIFICATION_VIEW");
    },
  },
};
</script>

<style scoped lang="less">
.m {
  &-header {
    height: 50px;
    line-height: unset;
    li {
      padding: 0 10px;
      border: 0;
      &:hover {
        border: 0;
      }
    }
    &-right {
      border: 0;
      background-color: transparent;
      color: white;
      > .ant-menu-item {
        i {
          margin: 0 auto;
        }

        &-selected {
          border-bottom-color: darken(@color-primary, 15);
          background: darken(@color-primary, 10);
          color: white;
        }
      }
    }
  }
}

.d-header,
.m-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px !important;
  color: white;
  background-color: @color-primary;
  box-shadow: 0 2px 8px #f0f1f2;
}

.m {
  &-header {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
}

.ant {
  &-form {
    &-item {
      margin-bottom: 0;
      &-label {
        line-height: 20;
      }
    }
  }
}

.upload {
  display: flex;
  flex-direction: row;
}
</style>